import { genufitMarkPngSrc, type GenufitMarkTone } from './genufitMarkAssets'

type GenufitMarkProps = {
  size?: number
  className?: string
  tone?: GenufitMarkTone
}

/** Locked Round 11 Concept Mirrored — bullseye + arrow L→R (HIR-84, Roman ee2dd03d). */
export function GenufitMark({ size = 40, className, tone = 'light' }: GenufitMarkProps) {
  return (
    <img
      src={genufitMarkPngSrc('sidebar', tone, size)}
      width={size}
      height={size}
      alt="GenuFit"
      className={className}
      data-testid="genufit-mark"
    />
  )
}
